import styles from "./styles.module.scss";
import { HeaderControlButtons, HeaderNav, HeaderSearch, UserInfo } from "./Components";

export const Desktop = () => {
  return (
    <header className={styles["app-header"]}>
      <UserInfo />
      <div className={styles["app-header-content"]}>
        <div className={styles["app-header-content-left"]}>
          <HeaderNav />
        </div>
        <div className={styles["app-header-content-right"]}>
          <HeaderSearch />
          <HeaderControlButtons />
        </div>
      </div>
    </header>
  );
};
